import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import heroBg from "/hero/63d3aeb8de61ca94deaa3955_Hero-Section Image.png";
import { Button } from "@/components/ui/button";

export default function Hero() {
  const navigate = useNavigate();
  const title = "THE INTELLIGENCE LAYER FOR MODERN UNIVERSITIES".split(" ");

  return (
    <section className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-20" id="hero">
      <div className="absolute inset-0 z-0">
        <img src={heroBg} alt="Hero background" className="w-full h-full object-cover" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center">
        <div className="flex flex-wrap justify-center gap-x-4 max-w-5xl mb-6">
          {title.map((word, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="text-5xl md:text-7xl lg:text-8xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-white to-primary tracking-tight leading-[0.85]"
            >
              {word}
            </motion.span>
          ))}
        </div>

        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-lg md:text-2xl text-white/80 max-w-2xl mb-10 font-sans"
        >
          Replace manual scheduling chaos with silent, precise automation. Command your resources fluidly.
        </motion.p>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row gap-4"
        >
          <Button 
            size="lg" 
            variant="outline" 
            style={{
              borderColor: 'rgba(0, 212, 200, 0.5)',
              color: '#00d4c8'
            }}
            className="h-14 px-8 text-lg font-bold tracking-wide rounded-none hover:bg-primary/10 transition-all backdrop-blur-md" 
            data-testid="btn-explore-platform"
            onClick={() => navigate('/student-form')}
          >
            EXPLORE PLATFORM
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
